export default __webpack_public_path__ + "static/media/Buttock.d1903d1c.svg";